import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";
import i18n from "i18next";

import { SortedList } from "../../Layout/SortedList";
import GroupedFile from "./GroupedFile";
import Time from "./../../Common/Time";

class Document extends PureComponent {
  static propTypes = {
    getDocuments: PropTypes.func.isRequired,
    documents: PropTypes.array,
    isLoading: PropTypes.bool,
    noResultMessage: PropTypes.string,
    noResultTitle: PropTypes.string
  };

  static defaultProps = {
    isLoading: false,
    documents: [],
    noResultMessage: "",
    noResultTitle: ""
  };

  componentDidMount() {
    this.props.getDocuments();
  }

  get documents() {
    return _(this.props.documents)
      .groupBy(x => x.documentTypeDisplay)
      .map((files, display) => ({ display, files }))
      .sortBy(x => x.display)
      .value();
  }

  render() {
    return (
      <div className="document__container">
        <div className="document__header">
          <p className="document__title">{i18n.t("document.documents")}</p>
          <Time />
        </div>
        <SortedList
          RowComponent={GroupedFile}
          className="sorted-list__documents"
          data={this.documents}
          isLoading={this.props.isLoading}
          noResultTitle={this.props.noResultTitle}
          noResultMessage={this.props.noResultMessage}
          keyBy="display"
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    documents: state.documents.documents
  };
};

export default connect(mapStateToProps)(Document);



// WEBPACK FOOTER //
// ./src/components/Common/Document/Document.js